export default __webpack_public_path__ + "88424fa5647e131a6a7d3dce5d247662.svg";